export default __webpack_public_path__ + "static/media/8@3x.366516d8.png";